// Translations
import form from '../sections/form/translations/ar'

// Translation: Verification > Landing (Arabic)
export default Object.freeze({
	sections: { form }
})
